/* eslint-disable camelcase */
import Boss from './Boss';
import env from './env';
import cookie from './cookie';
import { buildUrl } from './url';

function getUin() {
  let uin = parseInt(cookie.get('uin').replace(/^o0*/g, ''), 10);
  if (!uin || uin <= 10000) {
    uin = parseInt(cookie.get('luin').replace(/^o0*/g, ''), 10);
    if (!uin || uin <= 10000) {
      return 0;
    }
  }
  return uin;
}

export default class Reporter {
  constructor(bossId = 0, pwd = '', useAtta = false) {
    if (!bossId || !pwd) {
      throw new Error('[Reporter] bossId and pwd is missing, please get it from boss platform.');
    }
    this.boss = new Boss({
      bossId,
      pwd,
      useAtta,
    });

    this._queue = [];
  }

  init(options = {}) {
    this.boss.setBaseUrl(buildUrl(this.boss.getBaseUrl(), {
      f_url: location.pathname,
      f_dm: location.host,
      f_protocol: location.protocol,
      f_url_param: this._encodeUrl(location.href).split('?')[1] || '',
      f_ref: this._encodeUrl(document.referrer),
      f_platform: `${env.os}.${env.app}`,
      ...options,
    }, true));
  }

  /**
   * 用于异步上报，由业务自己控制上报时机
   */
  ready() {
    this._isInit = true;
    this._handleQueue();
  }

  report(params) {
    const loginType = cookie.get('main_login');
    const _params = {
      f_logintype: loginType && loginType !== 'none' ? loginType : '-',
      f_uid: (loginType === 'qq' ? cookie.get('vqq_openid') || getUin() : '') || cookie.get('openid'),
      f_vuid: (loginType === 'qq' ? cookie.get('vqq_vuserid') : '') || cookie.get('vuserid'),
      f_appid: (loginType === 'qq' ? cookie.get('vqq_appid') : '') || cookie.get('appid'),
      ...params,
    };
    if (!this._isInit) {
      this._queue.push(_params);
    } else {
      this.boss.report(_params);
    }
  }

  _handleQueue() {
    if (this._isInit) {
      Array.isArray(this._queue) && this._queue.forEach((v) => {
        this.boss.report(v);
      });
      this._queue = [];
    }
  }

  _encodeUrl(url) {
    try {
      url = decodeURIComponent(url);
    } catch (e) {
    }
    return this.boss._encodeDollor(url);
  }
}
